import React from 'react';
import { useState  } from 'react';
import { 
    Create, 
    TextInput, 
    SimpleForm, 
    Toolbar,
    SaveButton,
    SelectInput,
    BooleanInput,
    NumberInput,
    useTranslate,
    ReferenceInput,
    required } from 'react-admin';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from "@material-ui/core/Tooltip";
import Typography from '@material-ui/core/Typography';
import introJs from 'intro.js';
import 'intro.js/introjs.css';
import { useEffect } from 'react';

function arrowGenerator(color) {
    return {
      '&[x-placement*="bottom"] $arrow': {
        top: 0,
        left: 0,
        marginTop: '-0.95em',
        width: '3em',
        height: '1em',
        '&::before': {
          borderWidth: '0 1em 1em 1em',
          borderColor: `transparent transparent ${color} transparent`,
        },
      },
      '&[x-placement*="top"] $arrow': {
        bottom: 0,
        left: 0,
        marginBottom: '-0.95em',
        width: '3em',
        height: '1em',
        '&::before': {
          borderWidth: '1em 1em 0 1em',
          borderColor: `${color} transparent transparent transparent`,
        },
      },
      '&[x-placement*="right"] $arrow': {
        left: 0,
        marginLeft: '5px',
        height: '4em',
        top :"45%",
        width: '2em',
        '&::before': {
          borderWidth: '1em 1em 1em 0',
          borderColor: `transparent ${color} transparent transparent`,
        },
      },
      '&[x-placement*="left"] $arrow': {
        right: 0,
        marginRight: '1.3em',
        height: '3em',
        width: '1em',
        '&::before': {
          borderWidth: '1em 0 1em 1em',
          borderColor: `transparent transparent transparent ${color}`,
        },
      },
    };
  }

  const useStyles = makeStyles({
    arrow: {
        position: 'absolute',
        fontSize: 6,
        width: '3em',
        height: '3em',
        '&::before': {
          content: '""',
          margin: 'auto',
          display: 'block',
          width: 0,
          height: 0,
          borderStyle: 'solid',
        },
    },
    htmlPopper: arrowGenerator('#368a48'),
    htmlTooltip: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: "12px",
      border: '3px solid #368a48',
      '& b': {
        fontWeight: '12px',
      },
      boxShadow : '2px 2px 23px #338c46',
      borderRadius: '7px',
      marginTop: '10px'
    },
});

const CreateToolbar = ({ onCancel, ...props }) => {

    const translate = useTranslate();

    return (
       <Toolbar {...props}>
           <div>
                <SaveButton id='btnCreateUser' label="ra.action.add" {...props} />
                <Button onClick={onCancel} style={{position: 'absolute', right: '26px'}}>{translate('ra.action.cancel')}</Button>
           </div>
       </Toolbar>
)};

const UsuarioCreate = ({ onCancel, onSuccessOk, ...props }) => {
    const translate = useTranslate();
    const classes = useStyles();
    const [arrowRef, handleArrowRef] = useState(null);
    const inTour = JSON.parse(localStorage.getItem('activeTour'))

    let introHelp;
    introHelp = introJs('#root');
    introHelp.setOptions({
        disableInteraction: false,
        doneLabel: translate('traducciones.introBotones.doneLabel'),
        nextLabel: translate('traducciones.introBotones.nextLabel'),
        prevLabel: translate('traducciones.introBotones.prevLabel'),
        tooltipPosition:'top',
        steps: [
                {
                intro: translate('traducciones.introHelp.intro1'),
                title: translate('traducciones.introHelp.title1'),
                element: '#help'
                },
        ]                
    });

    const showHelp = () =>{
        const offPermisos = {
            querys: false,
            carga: false,
            admin: false,
            estructura: false,
        }
        if(document.cookie == 'introjs-dontShowAgain=true'){
            document.cookie = 'introjs-dontShowAgain =; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
                setTimeout(()=>{
                    introHelp.setOption("dontShowAgain", true).setOption("dontShowAgainLabel", translate('traducciones.introBotones.dontShow')).oncomplete(()=>{
                        crearCookie('introjs-dontShowAgain', 'true', 365)
                        localStorage.setItem('activeTour',JSON.stringify(offPermisos))
                    }).onexit(()=>{
                        crearCookie('introjs-dontShowAgain', 'true', 365)
                        localStorage.setItem('activeTour',JSON.stringify(offPermisos))
                    }).start();                         
                },500)
        }
    }

    function crearCookie(nombre, valor, diasParaExpirar) {
    var fechaExpiracion = new Date();
    fechaExpiracion.setDate(fechaExpiracion.getDate() + diasParaExpirar);
    var cookie = nombre + '=' + valor + '; expires=' + fechaExpiracion.toUTCString() + '; path=/';
    document.cookie = cookie;
    }

    const stepsToIntro = {
        createUser:
        [
            {
                intro: translate('traducciones.introUsuarioCreate.intro1'),
                title: translate('traducciones.introUsuarioCreate.title1'),
                element: "#createNombre",
                scrollTo: 'off',
            },
            {
                intro: translate('traducciones.introUsuarioCreate.intro2'),
                title: translate('traducciones.introUsuarioCreate.title2'),
                element: '#createEmail',
                scrollTo: 'off',
                position: 'bottom'
            },
            {
                intro: translate('traducciones.introUsuarioCreate.intro3'),
                title: translate('traducciones.introUsuarioCreate.title3'),
                element: '#createRol',
                scrollTo: 'off',
                position: 'bottom'
            },
            {
                intro: translate('traducciones.introUsuarioCreate.intro4'),
                title: translate('traducciones.introUsuarioCreate.title4'),
                element: '#createConfigPass',
                scrollTo: 'off',
                position: 'bottom'
            },
            {
                intro: translate('traducciones.introUsuarioCreate.intro5'),
                title: translate('traducciones.introUsuarioCreate.title5'),
                element: '#createVigencia',
                scrollTo: 'off',
                position: 'bottom'
            },
            {
                intro: translate('traducciones.introUsuarioCreate.intro6'),
                title: translate('traducciones.introUsuarioCreate.title6'),
                element: "#anotaciones",
                scrollTo: 'off',
            },
            {
                intro: translate('traducciones.introUsuarioCreate.intro7'),
                title: translate('traducciones.introUsuarioCreate.title7'),
                element: '#exportar',
                scrollTo: 'off',
                position: 'bottom'
            },
            {
                intro: translate('traducciones.introUsuarioCreate.intro8'),
                title: translate('traducciones.introUsuarioCreate.title8'),
                element: '#importar',
                scrollTo: 'off',
                position: 'bottom'
            },
            {
                intro: translate('traducciones.introUsuarioCreate.intro9'),
                title: translate('traducciones.introUsuarioCreate.title9'),
                element: '#digitalizar',
                scrollTo: 'off',
                position: 'bottom'
            },
            {
                intro: translate('traducciones.introUsuarioCreate.intro10'),
                title: translate('traducciones.introUsuarioCreate.title10'),
                element: '#imprimir',
                scrollTo: 'off',
                position: 'bottom'
            },
            {
                intro: translate('traducciones.introUsuarioCreate.intro11'),
                title: translate('traducciones.introUsuarioCreate.title11'),
                element: '#enviar',
                scrollTo: 'off',
                position: 'bottom'
            },
            {
                intro: translate('traducciones.introUsuarioCreate.intro12'),
                title: translate('traducciones.introUsuarioCreate.title12'),
                element: '#sinMarca',
                scrollTo: 'off',
                position: 'bottom'
            },
            {
                intro: translate('traducciones.introUsuarioCreate.intro13'),
                title: translate('traducciones.introUsuarioCreate.title13'),
                element: '#permisosConsultas',
                scrollTo: 'off',
                position: 'bottom'
            },
            // {
            //     intro: 'Después de haber ingresado todos los datos del nuevo usuario, simplemente haz clic aquí en el botón. Esto finalizará el proceso y creará la cuenta del usuario con las configuraciones que has especificado.',
            //     title: 'Crea tu nuevo usuario',
            //     element: '#btnCreateUser',
            //     scrollTo: 'off',
            //     position: 'left'
            // },
          ]       
    }

    let introDocuments;
    useEffect(() => {
        if(inTour.admin){
            setTimeout(()=>{
                introDocuments = introJs('#cont');
                introDocuments.setOptions({
                    disableInteraction: false,
                    doneLabel: translate('traducciones.introBotones.doneLabel'),
                    nextLabel: translate('traducciones.introBotones.nextLabel'),
                    prevLabel: translate('traducciones.introBotones.prevLabel'),
                    tooltipPosition:'top',
                    steps: stepsToIntro.createUser          
                  });
        
                introDocuments.setOption("dontShowAgain", true).setOption("dontShowAgainLabel", translate('traducciones.introBotones.dontShow')).oncomplete(()=>{
                    showHelp()
                }).onexit(()=>{
                    showHelp()
                }).start();
            },800)
        }
      }, []);

    return (
    <div>
    <Create {...props} onSuccess={ onSuccessOk }>
        <SimpleForm  toolbar={<CreateToolbar onCancel={onCancel} />}>
            <div id='cont' style={{ textAlign: 'center', width: '100%'}}>
                <div>{translate('traducciones.titulos.nuevoUsuario')}</div>
                <img src={"adduser.png"} style={{width: '60%'}} />
            </div>
            <Tooltip
                placement="left"
                classes={{ popper: classes.htmlPopper,tooltip: classes.htmlTooltip }}
                PopperProps={{ popperOptions: { modifiers: { arrow: { enabled: Boolean(arrowRef), element: arrowRef, },},},}}
                title={
                    <React.Fragment>
                        Captura el nombre de usuario de cada miembro de tu equipo
                        <span className={classes.arrow} ref={handleArrowRef} />
                    </React.Fragment>
                }>
                <TextInput id='createNombre' source="Nombre" label="traducciones.campos.nombre" validate={required()} />
            </Tooltip>
            <Tooltip
                placement="left"
                classes={{ popper: classes.htmlPopper,tooltip: classes.htmlTooltip }}
                PopperProps={{ popperOptions: { modifiers: { arrow: { enabled: Boolean(arrowRef), element: arrowRef, },},},}}
                title={
                    <React.Fragment>
                        Llena el correo electrónico, <br></br>
                        <b>Tip de seguridad:</b> te recomendamos siempre usar los correos institucionales.
                        <span className={classes.arrow} ref={handleArrowRef} />
                    </React.Fragment>
                }>
            <TextInput id='createEmail' source="Email" label="traducciones.campos.email" validate={required()} />
            </Tooltip>
            <Tooltip
                placement="left"
                classes={{ popper: classes.htmlPopper,tooltip: classes.htmlTooltip }}
                PopperProps={{ popperOptions: { modifiers: { arrow: { enabled: Boolean(arrowRef), element: arrowRef, },},},}}
                title={
                    <React.Fragment>
                        <Typography color="inherit">Tu eres el Administrador de tu equipo. ¡Felicidades!</Typography>
                        Puedes crear usuarios con perfil de seguridad, operador,  y usuario para agregar seguridad a tu información.Y para que tu equipo tenga solo las herramientas que le van a ayudar a desempeñar mejor su trabajo.
                        Tipos de perfil:<br></br><br></br>
                        <b>Seguridad</b><br></br>
                        - Permite crear usuarios y generar los perfiles de acceso<br></br>
                        - El perfil de seguridad consolida los passwords y tiene acceso a toda la información.<br></br>
                        - Define los permisos de cada usuario operador<br></br><br></br>
                        <b>Operador</b><br></br>
                        - Es el miembro del equipo que tiene acceso a la información de acuerdo a su perfil especifico, pero no puede invitar a nuevos miembros al equipo no reiniciar las contraseñas
                        <br></br><br></br>
                        <b>Usuario administrador</b><br></br>
                        - Permite crear usuarios y generar los perfiles de acceso<br></br>
                        - El perfil de seguridad consolida los passwords y tiene acceso a toda la información.<br></br>
                        - No puede crear mas perfiles de administración, debes contactar a ventas para mayor información.<br></br>
                        <span className={classes.arrow} ref={handleArrowRef} />
                    </React.Fragment>
                }>
            <ReferenceInput label="traducciones.campos.rol"  source="IdTipo" reference="rolesUsuario">
                        <SelectInput id='createRol' validate={required()}  />
                    </ReferenceInput>  
            </Tooltip>
            <Tooltip
                placement="left"
                classes={{ popper: classes.htmlPopper,tooltip: classes.htmlTooltip }}
                PopperProps={{ popperOptions: { modifiers: { arrow: { enabled: Boolean(arrowRef), element: arrowRef, },},},}}
                title={
                    <React.Fragment>
                        Cuando estas invitando a tu equipo puedes crear un password temporal, que el invitado puede usar una sola vez. Le puedes asignar una caducidad de tiempo con la siguiente función. Esta función es útil para  auditores externos o internos que no deben tener acceso permanente a lo mas valioso que tienes. Tu información.
                        <span className={classes.arrow} ref={handleArrowRef} />
                    </React.Fragment>
                }>
           <ReferenceInput label="traducciones.campos.estadoPassword"  source="EstadoPassword" reference="estadoPassword">
                        <SelectInput id='createConfigPass' validate={required()}  />
                    </ReferenceInput>
            </Tooltip>
            <NumberInput id='createVigencia' source="Vigencia" label="traducciones.campos.vigenciaPassword" defaultValue={ 0 } min="0" />
            <Tooltip
                placement="left"
                classes={{ popper: classes.htmlPopper,tooltip: classes.htmlTooltip }}
                PopperProps={{ popperOptions: { modifiers: { arrow: { enabled: Boolean(arrowRef), element: arrowRef, },},},}}
                title={
                    <React.Fragment>
                        Desliza las funciones y permisos que quieres darle a tu equipo. Esto te permite personalizar los accesos a la información tanto, como lo necesites para ajustarse a los perfiles de tu compañía.
                        <br></br>
                        <b>Tip de seguridad:</b> Revisa los perfiles de seguridad con RH o TI para que las funciones se adapten a las políticas de seguridad establecidas por tu empresa.
                        <span className={classes.arrow} ref={handleArrowRef} />
                    </React.Fragment>
                }>
            <div className="row rowNoMessage" style={{ width: '100%'}}>
                <hr className='hr-text' data-content={translate('traducciones.permisos.permDocumentos')}/>
                <div className="col-md-6">
                    <Tooltip
                    placement="left"
                    classes={{ popper: classes.htmlPopper,tooltip: classes.htmlTooltip }}
                    PopperProps={{ popperOptions: { modifiers: { arrow: { enabled: Boolean(arrowRef), element: arrowRef, },},},}}
                    title={
                        <React.Fragment>
                            La función anotaciones, sirve para generar trazabilidad, en esta función puedes crear marcas de agua, anotaciones que se requieran para algún proceso, o incluso firmar los documentos. Para conexión con APIS de firma digital como DOCUSIGN contacta a ventas.
                            <span className={classes.arrow} ref={handleArrowRef} />
                        </React.Fragment>
                    }>
                        <BooleanInput id='anotaciones' label="traducciones.permisos.anotaciones" defaultValue={false} source="Permissions.Anotaciones" />
                    </Tooltip>
                </div>
                <div className="col-md-6">
                <Tooltip
                    placement="left"
                    classes={{ popper: classes.htmlPopper,tooltip: classes.htmlTooltip }}
                    PopperProps={{ popperOptions: { modifiers: { arrow: { enabled: Boolean(arrowRef), element: arrowRef, },},},}}
                    title={
                        <React.Fragment>
                            La función Exportar, permite exportar una copia de los documentos de la plataforma, si activaste una marca de agua esta se vera reflejada en la exportacion. Puedes elegir que documentos, y que secciones de los documentos quieres exportar.
                            <b>Tip de seguridad:</b> activa esta función a usuarios externos como consultores, o auditores para que tengan la información que necesitan para realizar su trabajo.
                            <span className={classes.arrow} ref={handleArrowRef} />
                        </React.Fragment>
                    }>
                    <BooleanInput id='exportar' label="traducciones.permisos.exportar" defaultValue={false} source="Permissions.Exportar" />
                    </Tooltip>
                </div>
                <div className="col-md-6">
                <Tooltip
                    placement="left"
                    classes={{ popper: classes.htmlPopper,tooltip: classes.htmlTooltip }}
                    PopperProps={{ popperOptions: { modifiers: { arrow: { enabled: Boolean(arrowRef), element: arrowRef, },},},}}
                    title={
                        <React.Fragment>
                            La función anotaciones, sirve para generar trazabilidad, en esta función puedes crear marcas de agua, anotaciones que se requieran para algún proceso, o incluso firmar los documentos. Para conexión con APIS de firma digital como DOCUSIGN contacta a ventas.
                            <span className={classes.arrow} ref={handleArrowRef} />
                        </React.Fragment>
                    }>
                    <BooleanInput id='importar' label="traducciones.permisos.importar" defaultValue={false} source="Permissions.Importar" />
                    </Tooltip>
                </div>
                <div className="col-md-6">
                <Tooltip
                    placement="left"
                    classes={{ popper: classes.htmlPopper,tooltip: classes.htmlTooltip }}
                    PopperProps={{ popperOptions: { modifiers: { arrow: { enabled: Boolean(arrowRef), element: arrowRef, },},},}}
                    title={
                        <React.Fragment>
                            La función anotaciones, sirve para generar trazabilidad, en esta función puedes crear marcas de agua, anotaciones que se requieran para algún proceso, o incluso firmar los documentos. Para conexión con APIS de firma digital como DOCUSIGN contacta a ventas.
                            <span className={classes.arrow} ref={handleArrowRef} />
                        </React.Fragment>
                    }>
                    <BooleanInput id='digitalizar' label="traducciones.permisos.digitalizar" defaultValue={false} source="Permissions.Digitalizar" />
                    </Tooltip>
                </div>
                <div className="col-md-6">
                <Tooltip
                    placement="left"
                    classes={{ popper: classes.htmlPopper,tooltip: classes.htmlTooltip }}
                    PopperProps={{ popperOptions: { modifiers: { arrow: { enabled: Boolean(arrowRef), element: arrowRef, },},},}}
                    title={
                        <React.Fragment>
                            La función anotaciones, sirve para generar trazabilidad, en esta función puedes crear marcas de agua, anotaciones que se requieran para algún proceso, o incluso firmar los documentos. Para conexión con APIS de firma digital como DOCUSIGN contacta a ventas.
                            <span className={classes.arrow} ref={handleArrowRef} />
                        </React.Fragment>
                    }>
                    <BooleanInput id='imprimir' label="traducciones.permisos.imprimir" defaultValue={false} source="Permissions.Imprimir" />
                    </Tooltip>
                </div>
                <div className="col-md-6">
                <Tooltip
                    placement="left"
                    classes={{ popper: classes.htmlPopper,tooltip: classes.htmlTooltip }}
                    PopperProps={{ popperOptions: { modifiers: { arrow: { enabled: Boolean(arrowRef), element: arrowRef, },},},}}
                    title={
                        <React.Fragment>
                            La función anotaciones, sirve para generar trazabilidad, en esta función puedes crear marcas de agua, anotaciones que se requieran para algún proceso, o incluso firmar los documentos. Para conexión con APIS de firma digital como DOCUSIGN contacta a ventas.
                            <span className={classes.arrow} ref={handleArrowRef} />
                        </React.Fragment>
                    }>
                    <BooleanInput id='enviar' label="traducciones.permisos.enviar" defaultValue={false} source="Permissions.Enviar" />
                    </Tooltip>
                </div>
                <div className="col-md-6">
                    <BooleanInput id='sinMarca' label="traducciones.permisos.sinmarcaagua" defaultValue={false} source="Permissions.Sin_marca_de_agua" />
                </div>
                <hr className='hr-text' data-content={translate('traducciones.permisos.permConsultas')}/>
                <div className='row' id='permisosConsultas'>
                    <div className="col-md-6">
                        <BooleanInput label="traducciones.permisos.general" defaultValue={true} source="Permissions.Consulta_general" />
                    </div>
                    <div className="col-md-6">
                        <BooleanInput label="traducciones.permisos.navegar" defaultValue={true} source="Permissions.Consulta_navegar" />
                    </div>
                    <div className="col-md-6">
                        <BooleanInput label="traducciones.permisos.porCampos" defaultValue={true} source="Permissions.Consulta_por_campos" />
                    </div>
                    <div className="col-md-6">
                        <BooleanInput label="traducciones.permisos.porContenido" defaultValue={true} source="Permissions.Consulta_por_contenido" />
                    </div>
                </div>
            </div>
            </Tooltip>
        </SimpleForm>
    </Create>
    </div>
)};

export default UsuarioCreate;